import React, { useState, useRef, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./MainDashboard.css";
import axios from "axios";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightLong,
  faCalendarAlt,
  faInfo,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import HeaderMain from "./Components/HeaderMain.jsx";
import { useAuth } from "../context/AuthContext";
import TextAds from "../components/textAd.jsx";
import ImageVideoAds from "../components/imageVideoAd.jsx";
import styles from "./LandingPage.module.css";
import logo from "./images/logo.png";

import { motion, AnimatePresence } from "framer-motion";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Info, MapPin, Image } from "react-feather";

import adsImg from "./images/ads.jpg";
import arenaImg from "./images/arena.jpg";
import athletesImg from "./images/athletes.jpg";
import ecosystemImg from "./images/ecosystem.jpg";
import innovationImg from "./images/innovation.jpg";

gsap.registerPlugin(ScrollTrigger);

const baseIcons = [
  { icon: "🏀", id: "basketball", color: "#f28c38" },
  { icon: "⚽", id: "soccer", color: "#28a745" },
  { icon: "🎾", id: "tennis", color: "#f1c40f" },
  { icon: "🏈", id: "football", color: "#8b4513" },
  { icon: "🏐", id: "volleyball", color: "#3498db" },
  { icon: "🏒", id: "hockey", color: "#2c3e50" },
  { icon: "⚾", id: "baseball", color: "#c0392b" },
  { icon: "🏓", id: "pingpong", color: "#9b59b6" },
  { icon: "🏀", id: "basketball2", color: "#f28c38" },
  { icon: "⚽", id: "soccer2", color: "#28a745" },
  { icon: "🎾", id: "tennis2", color: "#f1c40f" },
  { icon: "🏈", id: "football2", color: "#8b4513" },
  { icon: "🏐", id: "volleyball2", color: "#3498db" },
  { icon: "🏒", id: "hockey2", color: "#2c3e50" },
  { icon: "⚾", id: "baseball2", color: "#c0392b" },
  { icon: "🏓", id: "pingpong2", color: "#9b59b6" },
];

const sports = [
  { name: "All", id: "all", icon: "🌍", color: "#0071bc" },
  { name: "Cricket", id: "cricket", icon: "🏏", color: "#28a745" },
  { name: "Football", id: "football", icon: "⚽", color: "#e74c3c" },
  { name: "Basketball", id: "basketball", icon: "🏀", color: "#f39c12" },
  { name: "Hockey", id: "hockey", icon: "🏒", color: "#2c3e50" },
  { name: "Snooker", id: "snooker", icon: "🎱", color: "#8e44ad" },
];
const dummyNews = [
  {
    id: 1,
    title: "Exciting Match Highlights",
    date: new Date().toISOString(),
    images: [adsImg], // put placeholder path or public URL
    source_type: "admin",
    sport_name: "Football",
  },
  {
    id: 2,
    title: "Upcoming Tournament Announced",
    date: new Date().toISOString(),
    images: [adsImg],
    source_type: "external",
    sport_name: "Tennis",
  },
  {
    id: 3,
    title: "Star Player Signs New Deal",
    date: new Date().toISOString(),
    images: [adsImg],
    source_type: "admin",
    sport_name: "Basketball",
  },
  {
    id: 4,
    title: "Local Club Wins Championship",
    date: new Date().toISOString(),
    images: [adsImg],
    source_type: "external",
    sport_name: "Cricket",
  },
  {
    id: 5,
    title: "Training Tips from Professionals",
    date: new Date().toISOString(),
    images: [adsImg],
    source_type: "admin",
    sport_name: "Athletics",
  },
  {
    id: 6,
    title: "New Sports Complex Opens",
    date: new Date().toISOString(),
    images: [adsImg],
    source_type: "external",
    sport_name: "Hockey",
  },
  {
    id: 7,
    title: "Historic Rivalry Renewed",
    date: new Date().toISOString(),
    images: [adsImg],
    source_type: "admin",
    sport_name: "Football",
  },
  {
    id: 8,
    title: "Women’s Team Sets Record",
    date: new Date().toISOString(),
    images: [adsImg],
    source_type: "external",
    sport_name: "Volleyball",
  },
  {
    id: 9,
    title: "New Tech in Sports Training",
    date: new Date().toISOString(),
    images: [adsImg],
    source_type: "admin",
    sport_name: "Swimming",
  },
  {
    id: 10,
    title: "Fans Celebrate Big Victory",
    date: new Date().toISOString(),
    images: [adsImg],
    source_type: "external",
    sport_name: "Rugby",
  },
];

const dummyArenas = [
  {
    id: "dummy1",
    name: "Sports Innovation Hub",
    address: "Downtown City",
    rating: { average: 4 },
    about_arena: "Where sports meets innovation.",
    logo: adsImg,
  },
  {
    id: "dummy2",
    name: "Elite Arena",
    address: "Uptown District",
    rating: { average: 5 },
    about_arena: "A premier arena for all major sports.",
    logo: arenaImg,
  },
  {
    id: "dummy3",
    name: "Athletes Center",
    address: "Westside Avenue",
    rating: { average: 3 },
    about_arena: "A hub dedicated to training athletes.",
    logo: athletesImg,
  },
  {
    id: "dummy4",
    name: "Ecosystem Ground",
    address: "Central Park",
    rating: { average: 4 },
    about_arena: "Eco-friendly arena for sustainable sports.",
    logo: ecosystemImg,
  },
  {
    id: "dummy5",
    name: "Innovation Sports Complex",
    address: "Tech Valley",
    rating: { average: 5 },
    about_arena: "Cutting-edge sports technology center.",
    logo: innovationImg,
  },
];

// Cricket-specific match data
const cricketScores = [
  {
    t1: "India",
    t2: "Australia",
    t1_flag: "https://flagcdn.com/w40/in.png",
    t2_flag: "https://flagcdn.com/w40/au.png",
    t1_score: "132/4",
    t2_score: "Yet to bat",
    overs: "(13.4)",
    isLive: true,
    tournament: "T20 World Cup",
    matchStatus: "Australia chose to bowl",
    sport: "Cricket",
  },
  {
    t1: "England",
    t2: "South Africa",
    t1_flag: "https://flagcdn.com/w40/gb-eng.png",
    t2_flag: "https://flagcdn.com/w40/za.png",
    t1_score: "89/2",
    t2_score: "Yet to bat",
    overs: "(10.2)",
    isLive: true,
    tournament: "ODI Series",
    matchStatus: "England chose to bat",
    sport: "Cricket",
  },
  {
    t1: "New Zealand",
    t2: "Pakistan",
    t1_flag: "https://flagcdn.com/w40/nz.png",
    t2_flag: "https://flagcdn.com/w40/pk.png",
    t1_score: "210/7",
    t2_score: "145/10",
    overs: "",
    isLive: false,
    tournament: "Test Match",
    matchStatus: "New Zealand won by 65 runs",
    sport: "Cricket",
  },
];

// Football-specific match data
const footballScores = [
  {
    t1: "Argentina",
    t2: "Brazil",
    t1_flag: "https://flagcdn.com/w40/ar.png",
    t2_flag: "https://flagcdn.com/w40/br.png",
    t1_score: "1",
    t2_score: "2",
    isLive: true,
    tournament: "Friendly Match",
    matchStatus: "Brazil won the toss",
    sport: "Football",
  },
  {
    t1: "Germany",
    t2: "France",
    t1_flag: "https://flagcdn.com/w40/de.png",
    t2_flag: "https://flagcdn.com/w40/fr.png",
    t1_score: "3",
    t2_score: "3",
    isLive: true,
    tournament: "UEFA Nations",
    matchStatus: "France to kick off",
    sport: "Football",
  },
  {
    t1: "Spain",
    t2: "Italy",
    t1_flag: "https://flagcdn.com/w40/es.png",
    t2_flag: "https://flagcdn.com/w40/it.png",
    t1_score: "0",
    t2_score: "1",
    isLive: false,
    tournament: "Euro Qualifiers",
    matchStatus: "Italy won the match",
    sport: "Football",
  },
];

// Basketball-specific match data
const basketballScores = [
  {
    t1: "Lakers",
    t2: "Warriors",
    t1_flag: "https://cdn.nba.com/logos/nba/1610612747/primary/L/logo.svg",
    t2_flag: "https://cdn.nba.com/logos/nba/1610612744/primary/L/logo.svg",
    t1_score: "98",
    t2_score: "102",
    isLive: true,
    tournament: "NBA Regular",
    matchStatus: "4th Quarter - 2:45 remaining",
    sport: "Basketball",
  },
  {
    t1: "Celtics",
    t2: "Knicks",
    t1_flag: "https://cdn.nba.com/logos/nba/1610612738/primary/L/logo.svg",
    t2_flag: "https://cdn.nba.com/logos/nba/1610612752/primary/L/logo.svg",
    t1_score: "112",
    t2_score: "105",
    isLive: false,
    tournament: "NBA Playoffs",
    matchStatus: "Celtics won the game",
    sport: "Basketball",
  },
];

// Combine all scores
const allScores = [...cricketScores, ...footballScores, ...basketballScores];

function Dashboard({ preview, selectTheSlot }) {
  const navigate = useNavigate();
  const [adsSelected, setAdsSelected] = useState([]);
  const [currentAdIndexes, setCurrentAdIndexes] = useState({
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 0,
    8: 0,
    9: 0,
    10: 0,
  });

  const [selectedAd, setSelectedAd] = useState(null);
  const [newsItems, setNewsItems] = useState([]);
  const [userPosts, setUserPosts] = useState([]);
  const [followedUserPosts, setFollowedUserPosts] = useState([]);
  const [date, setDate] = useState(new Date());
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const [topArenas, setTopArenas] = useState([]);
  const [nearbyArenas, setNearbyArenas] = useState([]);
  const [HoveredIndex, setHoveredIndex] = useState(null);
  const [selectedSport, setSelectedSport] = useState("All");
  const [hasMoreNews, setHasMoreNews] = useState(false);
  const [userInterests, setUserInterests] = useState([]);
  const [newsDisplayMessage, setNewsDisplayMessage] = useState("");
  const { user } = useAuth();
  const userId = user?.uid;
  const heroRef = useRef(null);
  const scoreboardRef = useRef(null);
  const [scoreboardAnimation, setScoreboardAnimation] = useState(false);

  useEffect(() => {
    if (user?.userInterests && Array.isArray(user.userInterests)) {
      setUserInterests(user.userInterests);
    } else {
      setUserInterests([]);
    }
  }, [user]);

  const decodeBuffer = (imageData) => {
    if (!imageData) return null;
    const base64Prefix = "data:image/jpeg;base64,";
    if (imageData.startsWith(base64Prefix)) {
      try {
        const base64String = imageData.slice(base64Prefix.length);
        const decoded = atob(base64String);
        return decoded === "null" ? null : decoded;
      } catch (error) {
        console.error("Error decoding base64 image:", error);
        return null;
      }
    }
    return imageData; // Fallback if not a base64 data URL
  };

  const scores = [
    {
      t1: "Argentina",
      t2: "Brazil",
      t1_flag: "https://flagcdn.com/w40/ar.png",
      t2_flag: "https://flagcdn.com/w40/br.png",
      t1_score: "1",
      t2_score: "2",
      isLive: true,
      highlights: ["Goal by Messi (45')", "Yellow card to Neymar (60')"],
    },
    {
      t1: "Germany",
      t2: "France",
      t1_flag: "https://flagcdn.com/w40/de.png",
      t2_flag: "https://flagcdn.com/w40/fr.png",
      t1_score: "3",
      t2_score: "3",
      isLive: true,
      highlights: ["Goal by Mbappé (30')", "Goal by Müller (55')"],
    },
    {
      t1: "Spain",
      t2: "Italy",
      t1_flag: "https://flagcdn.com/w40/es.png",
      t2_flag: "https://flagcdn.com/w40/it.png",
      t1_score: "0",
      t2_score: "1",
      isLive: false,
      highlights: ["Goal by Insigne (80')"],
    },
    {
      t1: "Japan",
      t2: "South Korea",
      t1_flag: "https://flagcdn.com/w40/jp.png",
      t2_flag: "https://flagcdn.com/w40/kr.png",
      t1_score: "2",
      t2_score: "2",
      isLive: true,
      highlights: ["Goal by Son (25')", "Goal by Minamino (70')"],
    },
    {
      t1: "Netherlands",
      t2: "Portugal",
      t1_flag: "https://flagcdn.com/w40/nl.png",
      t2_flag: "https://flagcdn.com/w40/pt.png",
      t1_score: "4",
      t2_score: "1",
      isLive: false,
      highlights: ["Goal by Depay (15')", "Goal by Ronaldo (88')"],
    },
    {
      t1: "United States",
      t2: "Mexico",
      t1_flag: "https://flagcdn.com/w40/us.png",
      t2_flag: "https://flagcdn.com/w40/mx.png",
      t1_score: "1",
      t2_score: "0",
      isLive: true,
      highlights: ["Goal by Pulisic (40')"],
    },
    {
      t1: "Norway",
      t2: "Sweden",
      t1_flag: "https://flagcdn.com/w40/no.png",
      t2_flag: "https://flagcdn.com/w40/se.png",
      t1_score: "2",
      t2_score: "3",
      isLive: false,
      highlights: ["Goal by Haaland (20')", "Goal by Isak (65')"],
    },
    {
      t1: "England",
      t2: "Scotland",
      t1_flag: "https://flagcdn.com/w40/gb-eng.png",
      t2_flag: "https://flagcdn.com/w40/gb-sct.png",
      t1_score: "1",
      t2_score: "1",
      isLive: true,
      highlights: ["Goal by Kane (50')", "Goal by McGinn (75')"],
    },
    {
      t1: "Saudi Arabia",
      t2: "Qatar",
      t1_flag: "https://flagcdn.com/w40/sa.png",
      t2_flag: "https://flagcdn.com/w40/qa.png",
      t1_score: "0",
      t2_score: "5",
      isLive: false,
      highlights: ["Goal by Afif (10')", "Goal by Ali (30')"],
    },
    {
      t1: "Thailand",
      t2: "Australia",
      t1_flag: "https://flagcdn.com/w40/th.png",
      t2_flag: "https://flagcdn.com/w40/au.png",
      t1_score: "3",
      t2_score: "2",
      isLive: true,
      highlights: ["Goal by Mooy (35')", "Goal by Chanathip (60')"],
    },
  ];

  const fetchPersonalizedNews = async () => {
    try {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const selectedDateStr = `${year}-${month}-${day}`;
      const url = `${process.env.REACT_APP_BASE_URL}/rss/api/all-news?selectedDate=${selectedDateStr}`;
      const response = await axios.get(url);

      if (response.data.success) {
        const allNews = response.data.news || [];

        // ✅ process admin news items to fetch images
        const processedNews = await Promise.all(
          allNews.map(async (newsItem) => {
            if (
              newsItem.source_type === "admin" &&
              newsItem.images === "images_available"
            ) {
              try {
                const adminNewsResponse = await axios.get(
                  `${process.env.REACT_APP_BASE_URL}/admin-news/api/news/${newsItem.id}`
                );
                return {
                  ...newsItem,
                  images: adminNewsResponse.data.images || [],
                  video_path:
                    adminNewsResponse.data.video_path || newsItem.video_path,
                };
              } catch (error) {
                console.error("Error fetching admin news details:", error);
                return { ...newsItem, images: [] };
              }
            }
            return newsItem;
          })
        );

        let filteredNews = [];
        let displayMessage = "";

        if (userInterests.length > 0) {
          const userSportIds = userInterests.map((interest) => interest.id);
          filteredNews = processedNews.filter(
            (newsItem) =>
              newsItem.sport_id && userSportIds.includes(newsItem.sport_id)
          );

          if (filteredNews.length > 0) {
            const sportNames = userInterests
              .map((interest) => interest.name)
              .join(", ");
            displayMessage = `Showing news for: ${sportNames}`;
          } else {
            filteredNews = processedNews
              .filter((newsItem) => newsItem.clicks > 0)
              .sort((a, b) => b.clicks - a.clicks);
            displayMessage = "Showing trending news from all sports";
          }
        } else {
          filteredNews = processedNews
            .filter((newsItem) => newsItem.clicks > 0)
            .sort((a, b) => b.clicks - a.clicks);
          displayMessage = "Showing trending news from all sports";
        }

        if (filteredNews.length === 0) {
          if (processedNews.length === 0) {
            displayMessage = `No news available on ${selectedDateStr}`;
          } else {
            filteredNews = processedNews.slice(0, 8);
            displayMessage = "Showing all available news";
          }
        }

        const limitedNews = filteredNews.slice(0, 8);
        setNewsItems(limitedNews);

        setNewsDisplayMessage(displayMessage);
        setHasMoreNews(processedNews.length > 0);
      } else {
        console.warn("News fetch unsuccessful:", response.data);
        setNewsItems([]);
        setHasMoreNews(false);
        setNewsDisplayMessage("");
      }
    } catch (error) {
      console.error("Error fetching personalized news:", error);
      try {
        const fallbackResponse = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/rss/api/dashboard-newsfeeds`
        );
        if (fallbackResponse.status === 200 && fallbackResponse.data) {
          const transformedNews = fallbackResponse.data.map((item, index) => ({
            id: `fallback-${index}`,
            title: item.title,
            link: item.link,
            date: item.pubDate,
            content: item.content,
            clicks: 0,
            sport_id: null,
            sport_name: null,
            source_type: "rss",
            video_path: null,
            images: null,
          }));
          setNewsItems(transformedNews);
          setHasMoreNews(true);
          setNewsDisplayMessage("Showing fallback news");
        } else {
          setNewsItems([]);
          setHasMoreNews(false);
          setNewsDisplayMessage("");
        }
      } catch (fallbackError) {
        console.error("Fallback error:", fallbackError);
        setNewsItems([]);
        setHasMoreNews(false);
        setNewsDisplayMessage("");
      }
    }
  };

  useEffect(() => {
    fetchPersonalizedNews();
  }, [date, userInterests, userId]);

  const handleNewsClick = async (newsItem) => {
    if (handleNewsClick.processing) return;
    handleNewsClick.processing = true;
    try {
      if (newsItem.source_type === "admin") {
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/admin-news/news/increment-click/${newsItem.id}`
        );
        navigate(`/display-user-news/${newsItem.id}`);
      } else {
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}/rss/api/increment-click/${newsItem.id}`
        );
        window.open(newsItem.link, "_blank");
      }
    } catch (error) {
      console.error("Error tracking click:", error);
      if (newsItem.source_type === "rss") {
        window.open(newsItem.link, "_blank");
      } else {
        navigate(`/display-user-news/${newsItem.id}`);
      }
    } finally {
      setTimeout(() => {
        handleNewsClick.processing = false;
      }, 1000);
    }
  };

  const handleViewMore = () => {
    navigate("/all-news");
  };

  useEffect(() => {
    const fetchUserPosts = async () => {
      const fetchedUserPosts = [
        {
          imageUrl:
            "https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0",
          description: "Slog 1",
        },
        {
          imageUrl: "https://images.unsplash.com/photo-1542291026-7eec264c27ff",
          description: "Slog 3",
        },
        {
          imageUrl:
            "https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0",
          description: "Slog 4",
        },
        {
          imageUrl: "https://images.unsplash.com/photo-1542291026-7eec264c27ff",
          description: "Slog 5",
        },
        {
          imageUrl:
            "https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0",
          description: "Slog 6",
        },
        {
          imageUrl: "https://images.unsplash.com/photo-1542291026-7eec264c27ff",
          description: "Slog 7",
        },
      ];
      setUserPosts(fetchedUserPosts);
    };

    const fetchFollowedUserPosts = async () => {
      const fetchedFollowedUserPosts = [
        {
          imageUrl:
            "https://images.unsplash.com/photo-1501785888041-af3ef285b470",
          description: "Slog 1",
        },
        {
          imageUrl:
            "https://images.unsplash.com/photo-1496317899792-9d7dbcd928a1",
          description: "Slog 2",
        },
        {
          imageUrl:
            "https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
          description: "Slog 3",
        },
        {
          imageUrl:
            "https://images.unsplash.com/photo-1501785888041-af3ef285b470",
          description: "Slog 4",
        },
        {
          imageUrl:
            "https://images.unsplash.com/photo-1496317899792-9d7dbcd928a1",
          description: "Slog 5",
        },
        {
          imageUrl:
            "https://images.unsplash.com/photo-1507525428034-b723cf961d3e",
          description: "Slog 6",
        },
        {
          imageUrl:
            "https://images.unsplash.com/photo-1501785888041-af3ef285b470",
          description: "Slog 7",
        },
      ];
      setFollowedUserPosts(fetchedFollowedUserPosts);
    };
    fetchUserPosts();
    fetchFollowedUserPosts();
  }, []);

  useEffect(() => {
    const fetchArenas = async () => {
      try {
        const topArenasResponse = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/common/GetTopFiveArenas`
        );

        setTopArenas(topArenasResponse.data);

        if (userId) {
          try {
            const nearbyArenasResponse = await axios.get(
              `${process.env.REACT_APP_BASE_URL}/api/common/GetNearbyArenas/${userId}`
            );

            const formattedNearbyArenas = nearbyArenasResponse.data.map(
              (arena) => {
                let logoSrc = "https://via.placeholder.com/100";
                if (arena.logo) {
                  if (typeof arena.logo === "string") {
                    logoSrc = arena.logo;
                  } else if (arena.logo.data) {
                    const base64 = btoa(
                      new Uint8Array(arena.logo.data).reduce(
                        (data, byte) => data + String.fromCharCode(byte),
                        ""
                      )
                    );
                    logoSrc = `data:${arena.logo.contentType};base64,${base64}`;
                  }
                }
                return {
                  ...arena,
                  logoSrc,
                  displayDistance: arena.distance
                    ? `${arena.distance} km`
                    : arena.location_type === "city"
                    ? "In your city"
                    : "",
                };
              }
            );
            setNearbyArenas(formattedNearbyArenas);
          } catch (nearbyError) {
            console.error("Error fetching nearby arenas:", nearbyError);
            setNearbyArenas([]);
          }
        } else {
          setNearbyArenas([]);
        }
      } catch (error) {
        console.error("Error fetching arenas:", error);
        setTopArenas([]);
        setNearbyArenas([]);
      }
    };

    fetchArenas();
  }, [userId]);

  const renderLogo = (logo) => {
    if (logo) {
      if (logo.startsWith("data:image")) {
        return logo;
      }
      return `data:image/jpeg;base64,${logo}`;
    }
    return null;
  };
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="fas fa-star text-yellow-400"></i>);
    }

    if (hasHalfStar) {
      stars.push(
        <i key="half" className="fas fa-star-half-alt text-yellow-400"></i>
      );
    }

    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <i key={`empty-${i}`} className="far fa-star text-gray-300"></i>
      );
    }

    return stars;
  };

  const toggleHoveredIndex = (index) => {
    if (HoveredIndex === index) {
      setHoveredIndex(null);
    } else {
      setHoveredIndex(index);
    }
  };

  const getRandomGridStyle = () => {
    const gridStyles = [
      "grid-style-1",
      "grid-style-2",
      "grid-style-3",
      "grid-style-4",
    ];
    const randomIndex = Math.floor(Math.random() * gridStyles.length);
    return gridStyles[randomIndex];
  };
  const [randomGridStyle, setRandomGridStyle] = useState(null);
  useEffect(() => {
    setRandomGridStyle(getRandomGridStyle());
  }, [newsItems]);

  const [searchTerm, setSearchTerm] = useState("");

  const [suggestions, setSuggestions] = useState([]);
  useEffect(() => {
    if (searchTerm.length > 0) {
      fetchSuggestions(searchTerm);
    } else {
      setSuggestions([]);
    }
  }, [searchTerm]);

  const fetchSuggestions = async (term) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/article/suggest-articles?term=${term}`
      );
      if (response.ok) {
        const data = await response.json();
        const processedSuggestions = data
          .map((article) => ({
            id: article.id,
            title: article.title || "Untitled",
            image: decodeBuffer(article.image),
          }))
          .filter((article) => article.id && article.title);
        setSuggestions(processedSuggestions);
      } else {
        console.error("Failed to fetch suggestions:", response.status);
        setSuggestions([]);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setSuggestions([]);
    }
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";
    const normalizedPath = imagePath.replace(/\\/g, "/");
    const url = `${process.env.REACT_APP_BASE_URL}/Uploads/${normalizedPath
      .split("/")
      .pop()}`;
    return url;
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSuggestionClick = (article) => {
    navigate(`/article/${article.id}`);
  };

  const handleSearch = () => {
    if (searchTerm.trim()) {
      navigate(`/search-results?q=${encodeURIComponent(searchTerm)}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const [ads, setAds] = useState([]);

  useEffect(() => {
    if (preview) return;

    let isMounted = true;
    let timeoutId;

    const fetchAds = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/download-ad`
        );
        if (isMounted) setAds(response.data.ads);
      } catch (error) {
        console.error("Error fetching ads:", error);
      }

      if (isMounted) {
        timeoutId = setTimeout(fetchAds, 500);
      }
    };

    fetchAds();

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [preview]);

  const handleClicks = async (e, ad) => {
    if (preview) {
      const id = e.currentTarget.dataset.id;

      if (
        ((id === "ad-1" || id === "ad-3" || id === "ad-5") &&
          preview === "image") ||
        ((id === "ad-2" || id === "ad-4" || id === "ad-6") &&
          preview === "video") ||
        ((id === "ad-7" ||
          id === "ad-8" ||
          id === "ad-9" ||
          id === "ad-10" ||
          id === "ad-11") &&
          preview === "text")
      ) {
        setSelectedAd(id);
        selectTheSlot(id);
      }
    }

    e.preventDefault();

    if (!ad || !ad.url) return;
    window.location.href = ad.url;
    ad.clicks = ad.clicks + 1;

    try {
      const jsonData = {
        clicks: ad.clicks,
        id: ad.ids,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/upload-clicks`,
        jsonData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.success) {
      } else {
        throw new Error(response.data.message || "Failed to upload clicks");
      }
    } catch (error) {
      console.error("Error uploading clicks:", error);
      alert("Failed to upload Clicks: " + error.message);
    }
  };

  const convertDate = (dateString) => {
    const dateObj = new Date(dateString);
    dateObj.setDate(dateObj.getDate());
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  useEffect(() => {
    const getCurrentAds = () => {
      const now = new Date();
      const isoDate = now.toISOString().slice(0, 10);
      const current_date = `${isoDate}T00:00:00`;
      const current_time = now.toTimeString().split(" ")[0];

      const newAds = [];

      for (const ad of ads) {
        const isDateInRange =
          ad.start_date.split("T")[0] <= current_date.split("T")[0] &&
          convertDate(current_date) <= ad.end_date.split("T")[0];

        const datePart = convertDate(current_date);
        const currentTime = new Date(`${datePart}T${current_time}`);
        const startTime = new Date(`${datePart}T${ad.start_time}`);
        const endTime = new Date(`${datePart}T${ad.end_time}`);
        const isTimeInRange =
          startTime <= currentTime && currentTime <= endTime;

        const isTimeIterRemaining = ad.total_time > 0;
        if (
          isDateInRange &&
          isTimeInRange &&
          isTimeIterRemaining &&
          ad.slotPlace.split(" ")[0] === "landingPage"
        ) {
          newAds.push(ad);
        }
      }

      if (JSON.stringify(adsSelected) !== JSON.stringify(newAds)) {
        const indexedAds = [];

        newAds.forEach((ad) => {
          const slotPlace = ad.slotPlace;
          const index = parseInt(slotPlace.trim().split(" ").pop(), 10);

          if (!isNaN(index)) {
            if (!indexedAds[index]) {
              indexedAds[index] = [];
            }
            indexedAds[index].push(ad);
          }
        });

        setAdsSelected(indexedAds);
      }
    };

    getCurrentAds();

    const interval = setInterval(() => {
      getCurrentAds();
    }, 1000);

    return () => clearInterval(interval);
  }, [ads]);

  const updateIterations = async (slot, i) => {
    if (!adsSelected[slot] || !adsSelected[slot][i]) return;

    try {
      const jsonData = {
        iterations: adsSelected[slot][i].iterations,
        total_time: adsSelected[slot][i].total_time,
        id: adsSelected[slot][i].ids,
        intervals: adsSelected[slot][i].intervals,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/upload-iterations`,
        jsonData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && response.data.success) {
      } else {
        throw new Error(response.data.message || "Failed to upload iterations");
      }
    } catch (error) {
      console.error("Error uploading iterations:", error);
      alert("Failed to upload Iterations: " + error.message);
    }
  };

  useEffect(() => {
    const timers = {};

    Object.keys(adsSelected).forEach((slotKey) => {
      const slot = parseInt(slotKey, 10);
      const adsInSlot = adsSelected[slot];
      const currentIndex = currentAdIndexes[slot];

      if (!adsInSlot || adsInSlot.length === 0 || currentIndex < 0) return;

      let nextIndex = currentIndex;

      const updateSlot = () => {
        if (
          currentIndex < adsInSlot.length &&
          adsInSlot[currentIndex]?.iterations > 0
        ) {
          updateIterations(slot, currentIndex);
        }

        nextIndex = (currentIndex + 1) % adsInSlot.length;

        if (adsInSlot[nextIndex]?.iterations <= 0) {
          const originalIndex = nextIndex;
          while (
            adsInSlot[nextIndex]?.iterations <= 0 &&
            nextIndex !== currentIndex
          ) {
            nextIndex = (nextIndex + 1) % adsInSlot.length;
            if (nextIndex === originalIndex) break;
          }
        }

        if (adsInSlot[nextIndex]?.iterations <= 0) return;

        setCurrentAdIndexes((prev) => ({
          ...prev,
          [slot]: nextIndex,
        }));
      };

      const interval =
        adsInSlot[currentIndex]?.iterations > 0
          ? adsInSlot[currentIndex]?.intervals
          : 1000;

      timers[slot] = setTimeout(updateSlot, interval);
    });

    return () => {
      Object.values(timers).forEach(clearTimeout);
    };
  }, [
    JSON.stringify(currentAdIndexes),
    JSON.stringify(
      Object.fromEntries(
        Object.entries(adsSelected).map(([slot, ads]) => [
          slot,
          ads.map((ad) => ad.iterations).join(","),
        ])
      )
    ),
  ]);

  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return;

    const frontLayer = hero.querySelector(`.${styles.frontLayer}`);
    const icons = hero.querySelectorAll(`.${styles.sportIcon}`);

    gsap.fromTo(
      frontLayer,
      { opacity: 0, y: 20 },
      { opacity: 0.7, y: 0, duration: 0.8, ease: "power2.out" }
    );

    icons.forEach((icon, index) => {
      gsap.to(icon, {
        x: `+=${Math.random() * 75 - 25}`,
        y: `+=${Math.random() * 75 - 25}`,
        duration: 3 + Math.random() * 3,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut",
        delay: index * 0.3,
        id: `drift-${index}`,
      });
    });

    const handleMouseMove = (e) => {
      const rect = hero.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      icons.forEach((icon, index) => {
        const iconRect = icon.getBoundingClientRect();
        const iconX = iconRect.left - rect.left + iconRect.width / 2;
        const iconY = iconRect.top - rect.top + iconRect.height / 2;

        const dx = mouseX - iconX;
        const dy = mouseY - iconY;
        const distance = Math.sqrt(dx * dx + dy * dy);

        const repelStrength = 30;
        const maxDistance = 150;
        if (distance < maxDistance && distance > 0) {
          const moveX =
            -(dx / distance) * (repelStrength * (1 - distance / maxDistance));
          const moveY =
            -(dy / distance) * (repelStrength * (1 - distance / maxDistance));

          gsap.to(icon, {
            x: `+=${moveX}`,
            y: `+=${moveY}`,
            duration: 0.4,
            ease: "power2.out",
            overwrite: false,
            id: `repel-${index}`,
          });
        }
      });
    };

    const handleMouseLeave = () => {
      icons.forEach((icon, index) => {
        gsap.to(icon, {
          x: 0,
          y: 0,
          duration: 0.4,
          ease: "power2.out",
          overwrite: `repel-${index}`,
        });
      });
    };

    const nameElement = hero.querySelector(`.${styles.nameHighlight}`);
    if (nameElement) {
      gsap.to(nameElement, {
        scale: 1.05,
        duration: 1.5,
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut",
        delay: 2,
      });
    }

    hero.addEventListener("mousemove", handleMouseMove);
    hero.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      hero.removeEventListener("mousemove", handleMouseMove);
      hero.removeEventListener("mouseleave", handleMouseLeave);
      gsap.killTweensOf(icons);
    };
  }, []);

  useEffect(() => {
    const sectionHeaders = document.querySelectorAll(
      `.${styles.sectionHeader} h2`
    );

    sectionHeaders.forEach((header) => {
      header.setAttribute("data-text", header.textContent);

      gsap.fromTo(
        header,
        {
          "--progress": 0,
        },
        {
          "--progress": 1,
          scrollTrigger: {
            trigger: header.parentElement.parentElement,
            start: "top 80%",
            end: "top 80%",
            scrub: true,
            onEnter: () => {
              gsap.to(header, {
                backgroundImage:
                  "linear-gradient(to right, #0071bce1, #0071bce1)",
                duration: 0.5,
              });
            },
            onLeaveBack: () => {
              gsap.to(header, {
                backgroundImage:
                  "linear-gradient(to right, #0071bce1, #0071bce1)",
                duration: 0.5,
              });
            },
          },
        }
      );

      // gsap.to(header.querySelector("::after"), {
      //   clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
      //   scrollTrigger: {
      //     trigger: header.parentElement.parentElement,
      //     start: "top 70%",
      //     end: "top 30%",
      //     scrub: true,
      //   },
      // });
    });

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  const stripMarkdownAndTruncate = (content, maxLength = 150) => {
    if (!content) return "";
    const stripped = content
      .replace(/#{1,6}\s+/g, "")
      .replace(/\*\*(.*?)\*\*/g, "$1")
      .replace(/\*(.*?)\*/g, "$1")
      .replace(/`(.*?)`/g, "$1")
      .replace(/\[(.*?)\]\(.*?\)/g, "$1")
      .replace(/!\[.*?\]\(.*?\)/g, "")
      .replace(/\n+/g, " ")
      .trim();
    return stripped.length > maxLength
      ? stripped.substring(0, maxLength) + "..."
      : stripped;
  };

  const handleSportSelect = (sport) => {
    setScoreboardAnimation(true);
    setSelectedSport(sport);
    setTimeout(() => setScoreboardAnimation(false), 800);
  };

  const filteredScores =
    selectedSport === "All"
      ? allScores
      : allScores.filter(
          (score) =>
            score.sport === selectedSport ||
            (selectedSport === "Football" && score.sport === "Football") ||
            (selectedSport === "Cricket" && score.sport === "Cricket") ||
            (selectedSport === "Basketball" && score.sport === "Basketball") ||
            (selectedSport === "Hockey" && score.sport === "Hockey") ||
            (selectedSport === "Snooker" && score.sport === "Snooker")
        );

  const renderScoreCard = (score, index) => {
    const isCricket = score.sport === "Cricket";
    const isFootball = score.sport === "Football";
    const isBasketball = score.sport === "Basketball";

    return (
      <motion.div
        key={`${selectedSport}-${score.id || index}`}
        className={styles.scoreCard}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: index * 0.1 }}
        whileHover={{ scale: 1.05 }}
      >
        <div className={styles.tournamentName}>
          {score.tournament}

          {score.isLive && (
            <div className={styles.liveIndicator}>
              <div className={styles.liveDot}></div>
              <span>LIVE</span>
            </div>
          )}
        </div>
        <div className={styles.matchDetails}>
          <div className={styles.teamRow}>
            <div className={styles.team}>
              <img
                src={score.t1_flag}
                alt={score.t1}
                className={styles.teamFlag}
              />
              <span className={styles.teamName}>{score.t1}</span>
            </div>
            <div className={styles.teamScore}>
              {score.t1_score}
              {isCricket && <span className={styles.overs}>{score.overs}</span>}
            </div>
          </div>

          <div className={styles.teamRow}>
            <div className={styles.team}>
              <img
                src={score.t2_flag}
                alt={score.t2}
                className={styles.teamFlag}
              />
              <span className={styles.teamName}>{score.t2}</span>
            </div>
            <div className={styles.teamScore}>{score.t2_score}</div>
          </div>
        </div>

        <div className={styles.matchStatus}>{score.matchStatus}</div>
      </motion.div>
    );
  };
  const dummyArenas = [
    {
      id: "dummy1",
      name: "Sports Innovation Hub",
      address: "Downtown City",
      rating: { average: 4 },
      about_arena:
        "Where sports meets innovation. Where sports meets innovation. Where sports meets innovation.",
      logo: adsImg,
    },
    {
      id: "dummy2",
      name: "Elite Arena",
      address: "Uptown District",
      rating: { average: 5 },
      about_arena:
        "A premier arena for all major sports. Where sports meets innovation. Where sports meets innovation.",
      logo: arenaImg,
    },
    {
      id: "dummy3",
      name: "Athletes Center",
      address: "Westside Avenue",
      rating: { average: 3 },
      about_arena:
        "A hub dedicated to training athletes. Where sports meets innovation. Where sports meets innovation. Where sports meets innovation.",
      logo: athletesImg,
    },
    {
      id: "dummy4",
      name: "Ecosystem Ground",
      address: "Central Park",
      rating: { average: 4 },
      about_arena:
        "Eco-friendly arena for sustainable sports. Where sports meets innovation. Where sports meets innovation.",
      logo: ecosystemImg,
    },
    {
      id: "dummy5",
      name: "Innovation Sports Complex",
      address: "Tech Valley",
      rating: { average: 5 },
      about_arena:
        "Cutting-edge sports technology center. Where sports meets innovation. Where sports meets innovation. Where sports meets innovation.",
      logo: innovationImg,
    },
  ];
  const renderArenaCard = (arena, index) => {
    return (
      <div key={index} className={styles.card}>
        <div className={styles.info}>
          <div>
            <h3 className={styles.name}>
              <div className={styles.cardImage}>
                {renderLogo(arena.logo) ? (
                  <img
                    src={renderLogo(arena.logo)}
                    alt={arena.name}
                    className={styles.image}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://upload.wikimedia.org/wikipedia/commons/a/a3/Arena-bukareszt.jpg";
                    }}
                  />
                ) : (
                  <div className={styles.placeholderImage}>
                    <Image size={48} />
                    <p>No image available</p>
                  </div>
                )}
              </div>
              <div>
                {arena.name}
                <div style={{ flexDirection: "initial" }}>
                  {renderStars(parseFloat(arena.rating.average))}
                </div>
                <p className={styles.location}>
                  <MapPin size={12} />
                  {arena.location || arena.address}
                </p>
              </div>
            </h3>
          </div>
          <div className={styles.about}>
            <p>{arena.about_arena || "No description available"}</p>
          </div>
          <div className={styles.buttonGroup}>
            <button
              className={`${styles.button} ${styles.bookButton}`}
              onClick={() => navigate(`/user-dashboard`)}
            >
              Book Now
            </button>
            <button
              className={`${styles.button} ${styles.detailsButton}`}
              onClick={() => navigate(`/arena-details/${arena.id}`)}
            >
              <Info size={12} /> Details
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="App" style={{ pointerEvents: preview ? "none" : "auto" }}>
      <HeaderMain pageType="home" />
      <main className={styles.mainContainer}>
        <motion.section
          className={`${styles.heroSection} `}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          ref={heroRef}
        >
          <div className={styles.frontLayer}>
            {baseIcons.map((icon, index) => (
              <motion.div
                key={icon.id}
                className={styles.sportIcon}
                style={{
                  color: icon.color,
                  left: `${10 + index * 5}%`,
                  top: `${20 + (index % 3) * 20}%`,
                }}
                whileHover={{ scale: 1.3, opacity: 0.9 }}
                transition={{ duration: 0.3 }}
              >
                {icon.icon}
              </motion.div>
            ))}
          </div>
          <motion.div className={styles.heroContent}>
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className={styles.punchline}
            >
              <motion.span
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.4, delay: 0.3 }}
              >
                Step Into The
              </motion.span>
              <motion.span
                className={styles.accentText}
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 300,
                  delay: 0.5,
                }}
              >
                Action
              </motion.span>
            </motion.h1>

            <motion.p
              className={styles.subline}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              {["Book", "Play", "Compete", "Repeat"].map((word, i) => (
                <motion.span
                  key={i}
                  className={styles.cyclingWord}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.4,
                    delay: 1 + i * 0.3,
                  }}
                >
                  {word}
                  {i < 3 && <span className={styles.divider}>•</span>}
                </motion.span>
              ))}
            </motion.p>
          </motion.div>
        </motion.section>

        <div className={styles.adsContainer}>
          <div className={styles.contentSection}>
            <TextAds
              adsSelected={adsSelected}
              currentAdIndexes={currentAdIndexes}
              selectedAd={selectedAd}
              handleClicks={handleClicks}
              preview={preview}
              slot={7}
            />
            <section
              id="live-scores"
              className={`${styles.liveScoresSection} `}
            >
              <motion.div
                className={styles.sectionHeader}
                initial={{ y: -50, opacity: 0 }}
                animate={
                  scoreboardAnimation
                    ? { y: 0, opacity: 1 }
                    : { y: 0, opacity: 1 }
                }
                transition={{ duration: 0.8, ease: "easeOut" }}
                ref={scoreboardRef}
              >
                <h2>
                  Live Scores
                  <motion.span
                    className={styles.scoreboardIcon}
                    initial={{ y: 100, opacity: 0 }}
                    animate={
                      scoreboardAnimation
                        ? { y: 0, opacity: 1 }
                        : { y: 0, opacity: 1 }
                    }
                    transition={{ duration: 0.5, ease: "easeOut" }}
                  ></motion.span>
                </h2>
              </motion.div>

              {/* Scores Carousel */}
              <div className={styles.scoresCarousel}>
                <AnimatePresence mode="wait">
                  {filteredScores.length > 0 ? (
                    filteredScores.map((score, index) =>
                      renderScoreCard(score, index)
                    )
                  ) : (
                    <div className={styles.noScores}>
                      <p>No live matches available for {selectedSport}</p>
                    </div>
                  )}
                </AnimatePresence>
              </div>
              {/* Sports Selection Carousel */}
              <div className={styles.sportsCarousel}>
                {sports.map((sport, index) => (
                  <div
                    key={index}
                    className={`${styles.sportBubble} ${
                      selectedSport === sport.name ? styles.selectedBubble : ""
                    }`}
                    onClick={() => handleSportSelect(sport.name)}
                    style={{
                      color:
                        selectedSport === sport.name ? sport.color : "#495057",
                      borderColor:
                        selectedSport === sport.name ? sport.color : "#dee2e6",
                    }}
                  >
                    <span>{sport.icon}</span>
                    <span>{sport.name}</span>
                  </div>
                ))}
              </div>
            </section>
            <TextAds
              adsSelected={adsSelected}
              currentAdIndexes={currentAdIndexes}
              selectedAd={selectedAd}
              handleClicks={handleClicks}
              preview={preview}
              slot={8}
            />
            <section id="arenas" className={`${styles.arenasSection} `}>
              <div className={styles.sectionHeader}>
                <h2>Top Arenas</h2>
              </div>

              <div className={styles.arenasCarousel}>
                {topArenas.length > 0 ? (
                  topArenas.map((arena, index) => (
                    <div key={index} className={styles.arenaCardCarousel}>
                      <div className={styles.arenaImageContainer}>
                        <img
                          src={renderLogo(arena.logo)}
                          alt={arena.name}
                          className={styles.arenaImage}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://via.placeholder.com/300";
                          }}
                        />
                      </div>

                      <h3 className={styles.arenaName}>{arena.name}</h3>

                      <div className={styles.arenaLocation}>
                        {arena.address || "Location not specified"}
                      </div>

                      <div className={styles.arenaRating}>
                        {[...Array(5)].map((_, i) => (
                          <span key={i} className={styles.star}>
                            {i < Math.floor(arena.rating?.average || 0)
                              ? "★"
                              : "☆"}
                          </span>
                        ))}
                      </div>

                      <p className={styles.arenaDescription}>
                        {arena.about_arena || "No description available"}
                      </p>

                      <div className={styles.arenaButtons}>
                        <button
                          className={`${styles.arenaButton} ${styles.bookButton}`}
                          onClick={() => navigate(`/user-dashboard`)}
                        >
                          Book Now
                        </button>
                        <button
                          className={`${styles.arenaButton} ${styles.detailsButton}`}
                          onClick={() => navigate(`/arena-details/${arena.id}`)}
                        >
                          Details
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className={styles.noScores}>
                    <p>No Arenas Available</p>
                  </div>
                )}
              </div>
            </section>
            <TextAds
              adsSelected={adsSelected}
              currentAdIndexes={currentAdIndexes}
              selectedAd={selectedAd}
              handleClicks={handleClicks}
              preview={preview}
              slot={9}
            />
            <section id="news" className={`${styles.newsSection} `}>
              <div className={styles.sectionHeader}>
                <h2>Sports News</h2>
                <motion.button
                  className={styles.calendarButton}
                  onClick={() => setIsCalendarVisible((prev) => !prev)}
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <FontAwesomeIcon icon={faCalendarAlt} />
                  <p>Select Date</p>
                </motion.button>
              </div>
              <div className={styles.newsContainer}>
                <div className={styles.newsGrid}>
                  {newsItems.length > 0 ? (
                    newsItems.map((news, index) => (
                      <motion.div
                        key={index}
                        className={styles.newsCard}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                        whileHover={{ scale: 1.02 }}
                        onClick={() => handleNewsClick(news)}
                      >
                        <div className={styles.newsImageContainer}>
                          <img
                            src={
                              news.images?.[0] ||
                              "https://via.placeholder.com/300"
                            }
                            alt={news.title}
                            className={styles.newsImage}
                          />
                        </div>
                        <div className={styles.newsContent}>
                          {/* <div className={styles.newsMeta}>
                      <span className={styles.newsDate}>
                        {new Date(news.date).toLocaleDateString("en-US", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })}
                      </span>
                      <span className={styles.newsSource}>
                        {news.source_type === "admin" ? "Official" : "External"}
                      </span>
                    </div> */}

                          <div className={styles.newsTags}>
                            <span className={styles.tag}>
                              {news.source_type === "admin"
                                ? "Official"
                                : "News"}
                            </span>
                            {news.sport_name && (
                              <span
                                className={`${styles.tag} ${styles.sportTag}`}
                              >
                                {news.sport_name}
                              </span>
                            )}
                          </div>
                          <h3>{news.title}</h3>
                          <span className={styles.newsDate}>
                            {new Date(news.date).toLocaleDateString("en-US", {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                            })}
                          </span>
                          {/* <span className={styles.readMore}>Read more</span> */}
                        </div>
                      </motion.div>
                    ))
                  ) : (
                    <div className={styles.noNewsMessage}>
                      <p>No news available for the selected date.</p>
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.newsControls}>
                <div className={styles.viewMoreWrapper}></div>
                {hasMoreNews && (
                  <motion.button
                    className={styles.viewMoreButton}
                    onClick={handleViewMore}
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    View All News
                  </motion.button>
                )}
              </div>
            </section>
            <TextAds
              adsSelected={adsSelected}
              currentAdIndexes={currentAdIndexes}
              selectedAd={selectedAd}
              handleClicks={handleClicks}
              preview={preview}
              slot={10}
            />
            <section
              id="informatica"
              className={`${styles.informaticaSection} `}
            >
              <div className={styles.sectionHeader}>
                <h2>Search Soul</h2>
              </div>
              <div className={`${styles.searchContainer} ${styles.mainSearch}`}>
                <input
                  type="text"
                  placeholder="Search Articles"
                  className={styles.mainSearchBar}
                  value={searchTerm}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                />
                <FontAwesomeIcon
                  icon={faSearch}
                  className={styles.searchIcon}
                />
                {suggestions.length > 0 ? (
                  <ul className={styles.suggestions}>
                    {suggestions.map((article, index) => (
                      <li
                        key={article.id || index}
                        onClick={() => handleSuggestionClick(article)}
                      >
                        {article.image && (
                          <img
                            src={getImageUrl(article.image)}
                            alt={`${article.title} thumbnail`}
                            loading="lazy"
                            onError={() =>
                              console.error(
                                `Failed to load image for ${
                                  article.title
                                }: ${getImageUrl(article.image)}`
                              )
                            }
                          />
                        )}
                        <span className={styles.suggestionTitle}>
                          {article.title}
                        </span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p></p>
                )}
              </div>
            </section>

            <AnimatePresence>
              {isCalendarVisible && (
                <motion.div
                  className={styles.calendarModal}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={() => setIsCalendarVisible(false)}
                >
                  <motion.div
                    className={styles.calendarContent}
                    initial={{ scale: 0.8 }}
                    animate={{ scale: 1 }}
                    exit={{ scale: 0.8 }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className={styles.calendarHeader}>
                      <h3>Select Date</h3>
                      <button onClick={() => setIsCalendarVisible(false)}>
                        ×
                      </button>
                    </div>
                    <Calendar
                      onChange={(newDate) => {
                        setDate(newDate);
                        setIsCalendarVisible(false);
                      }}
                      value={date}
                      className={styles.calendar}
                      formatShortWeekday={(locale, value) =>
                        ["S", "M", "T", "W", "T", "F", "S"][value.getDay()]
                      }
                    />
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <div className={styles.adsSection}>
            <ImageVideoAds
              adsSelected={adsSelected}
              currentAdIndexes={currentAdIndexes}
              preview={preview}
              handleClicks={handleClicks}
              selectedAd={selectedAd}
              slot1={1}
              slot2={2}
            />
            <ImageVideoAds
              adsSelected={adsSelected}
              currentAdIndexes={currentAdIndexes}
              preview={preview}
              handleClicks={handleClicks}
              selectedAd={selectedAd}
              slot1={3}
              slot2={4}
            />
            <ImageVideoAds
              adsSelected={adsSelected}
              currentAdIndexes={currentAdIndexes}
              preview={preview}
              handleClicks={handleClicks}
              selectedAd={selectedAd}
              slot1={5}
              slot2={6}
            />
          </div>
        </div>
      </main>
      <footer className={styles.footer}>
        <div className={styles.footerContainer}>
          <div className={styles.footerLogo}>
            <img src={logo} alt="Dsportshub Logo" />
          </div>
          <div className={styles.footerLinks}>
            <div className={styles.footerColumn}>
              <h4>Company</h4>
              <a href="#about">About Us</a>
              <a href="#careers">Careers</a>
              <a href="#contact">Contact</a>
            </div>
            <div className={styles.footerColumn}>
              <h4>Resources</h4>
              <a href="#blog">Blog</a>
              <a href="#help">Help Center</a>
              <a href="#privacy">Privacy Policy</a>
            </div>
            <div className={styles.footerColumn}>
              <h4>Connect</h4>
              <a href="#twitter">Twitter</a>
              <a href="#linkedin">LinkedIn</a>
              <a href="#instagram">Instagram</a>
            </div>
          </div>
          <div className={styles.footerBottom}>
            <p>
              &copy; {new Date().getFullYear()} Dsportshub. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Dashboard;
